<template>
    <div>
        <p>
            <span v-b-tooltip.hover title="Exemple : -site:amazon.fr pour exclure amazon.fr des résultats, site:amazon.com OR site:gibson.com pur ne récupérer les résuultats que de amazon.com ou gibson.com">Filtres</span>
            <b-input v-model="filters"></b-input>
        </p>

        <b-button @click="search()">Rechercher</b-button>

        <div v-for="(result, idx) in results" :key="idx">
            <p>Recherche : {{result.query}}</p>
            <div>Résultats</div>
            <b-card v-for="(r, idx) in result.result" :key="idx">
                <b>Position:</b> {{r.position}}<br />
                <b>Titre:</b> {{r.title}}<br />
                <b>Lien:</b> {{r.link}}<br />
                <b>Lien affiché:</b> {{r.displayed_link}}<br />
                <b>Texte:</b> {{r.snippet}}
            </b-card>
        </div>

		<div v-if="spinner" class="center_spinner">
			<fade-loader></fade-loader>
		</div>
    </div>
</template>

<script>
	var clone = require("clone");

    import workers from "../../services/workers.js";
    import treatments from "../../services/treatments.js";
	import utils_treatments from "../../utils/treatment.js";
    import edit_tabulator from "../../components/edit_tabulator.vue";

    import moment from "moment";
	import * as json2csv from "json2csv";
    import FadeLoader from "vue-spinner/src/FadeLoader.vue";

    export default {
		components: {
			edit_tabulator,
            FadeLoader
		},
		data() {
			return {
                filters: "",
                results: [],

                spinner: false
            }
        },
        props: {
            test_data: {
				default: () => []
            },
            column_brand: "",
            brand: "",
            column_name: "",
        },
        watch:
        {
        },
        methods: {
            async load(data)
            {
                this.filters = data.filters || "";
            },
            async save()
            {
                return {

                }
            },
            async search(filters)
            {
                this.spinner = true;

                var data = clone(this.test_data);
                this.results = [];

                for (var i = 0; i < data.length; i++)
                {
                    if (data[i][this.column_brand] != this.brand)
                    {
                        data.splice(i, 1);
                        i--;
                    }
                }

                data = data.slice(0, 10);

                var str_csv = json2csv.parse(data, {
					fields: Object.keys(data[0]),
					fieldNames: Object.keys(data[0]),
				});

				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

				var formData = new FormData();
				formData.append(files[0].name, files[0], "data.csv");
				formData.append("action", "api");

                var request = {
                    column_result: "result",
                    column_error: "error",
                    unique: false,
                    uri: "https://serpapi.com/search",
                    qs: [
                        ""
                    ],
                    qs_params: {
                        api_key: "serpapi_key",
                        engine: "google",
                        q: "${data['" + this.column_name + "']} " + this.filters,
                        num: 20
                    },
                    options_template: true
                }

                formData.append("parameters", JSON.stringify(request));

                var results = await workers.test(formData);

                var data = await treatments.getFileAlyx(
					results.data.files[0].url,
					false,
					false
				);
				let fileName = results.data.files[0].name;
                
                data = this.$papa.parse(data, { header: true });
                data = data.data;                

                for (var i = 0; i < data.length; i++)
                {
                    console.log(data[i])
                    data[i].result = JSON.parse(data[i].result);
                    data[i].query = data[i].result.search_information.query_displayed;
                    if (data[i].result && data[i].result.organic_results)
                    {
                        var organic_results = []
                        for (var j = 0; j < data[i].result.organic_results.length && j < 100; j++)
                        {
                            organic_results.push({
                                id: this.$uuid.v4(),
                                position: data[i].result.organic_results[j].position,
                                title: data[i].result.organic_results[j].title,
                                link: data[i].result.organic_results[j].link,
                                displayed_link: data[i].result.organic_results[j].displayed_link,
                                snippet: data[i].result.organic_results[j].snippet
                            });
                        }
                    }
                    data[i].result = organic_results;
                }

                this.results = data;

                console.log(this.results)

                this.spinner = false;
            }
        },
		mounted: async function () {
        }
    }
</script>

<style scoped>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
        margin-bottom: 60px;
	}
    .table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
        background-color: WhiteSmoke;
    }
</style>